//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import hasPages from '~/mixins/hasPages'
import hasWindow from '~/mixins/hasWindow'
import hasFaqs from '~/mixins/hasFaqs'
import hasCategories from '~/mixins/hasCategories'
import Category from '~/models/Category'
import Role from '~/models/Role'
import FaqListItem from '~/components/faq/FaqListItem'

export default {
  components: { FaqListItem },
  mixins: [hasPages, hasWindow, hasFaqs, hasCategories],

  // eslint-disable-next-line handle-callback-err
  async fetch({ error, query, store }) {
    try {
      await store.dispatch('categories/fetch', { type: Category.TYPE_FAQ })
      await store.dispatch('faqs/fetch', query)
    } catch (e) {
      if (get(e, 'response.status') === 404) {
        error({ statusCode: 404, message: 'Halaman tidak ditemukan.' })
      } else {
        throw e
      }
    }
  },

  data() {
    return {
      faqs: [],
      categories: [],
      isFetchingFaq: false,
      isFetchingCategory: false,
      search: '',
    }
  },

  computed: {
    articlesTitle() {
      switch (this.$auth.contentRole) {
        case Role.ROLE_GIRL:
          return 'Artikel Lain untuk Girls'
        case Role.ROLE_PARENT:
          return 'Artikel Lain untuk Orang Tua'
      }
      return 'Artikel Lain'
    },
    categoriesParams() {
      return {
        type: Category.TYPE_FAQ,
      }
    },
  },

  watch: {
    '$route.query'() {
      this.loadFaqs()
    },
    search() {
      this.loadFaqs()
    },
  },

  mounted() {
    this.loadCategories()
    this.loadFaqs()
  },

  methods: {
    async loadFaqs() {
      try {
        this.isFetchingFaq = true
        const params = {
          ...this.$route.query,
          search: this.search,
        }
        await this.$store.dispatch('faqs/fetch', params)
        this.faqs = this.getFaqs(params)
        this.lastMeta = get(this.getFaqsResult(params), 'meta')
      } catch (e) {
        this.isFetchingFaq = false
      } finally {
        this.isFetchingFaq = false
      }
    },
    async loadCategories() {
      try {
        this.isFetchingCategory = true
        await this.$store.dispatch('categories/fetch', this.categoriesParams)
        const categories = this.getCategories(this.categoriesParams)
        this.categories = categories
        this.$router.replace({
          name: 'tanya-kami',
          query: { ...this.$route.query, category_id: categories[0].id },
        })
        this.lastMeta = get(
          this.getCategoriesResult(this.categoriesParams),
          'meta'
        )
      } catch (e) {
        this.isFetchingCategory = false
      } finally {
        this.isFetchingCategory = false
      }
    },
  },

  head() {
    return {
      title: 'Temukan Jawaban Seputar Menstruasi di Sini! | Charmgirlstalk',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Berikut kumpulan pertanyaan yang banyak dari kamu belum ketahui jawabannya. Yuk cari pertanyaan mu di sini dan tentunya, kamu juga bisa tanya langsung di sini!',
        },
      ],
    }
  },
}
